import { render, staticRenderFns } from "./AdminAssets.vue?vue&type=template&id=5dd6dec1&scoped=true"
import script from "./AdminAssets.vue?vue&type=script&lang=js"
export * from "./AdminAssets.vue?vue&type=script&lang=js"
import style0 from "./AdminAssets.vue?vue&type=style&index=0&id=5dd6dec1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd6dec1",
  null
  
)

export default component.exports